<section id="nortonDetails" class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <section class="rs-es-first-section">
      <mprd-back-link></mprd-back-link>
      <div class="row" *ngIf="!isNortonFamily">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2">
            {{ 'norton.details.title' | translate }}
          </h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <p [innerHTML]="'norton.details.description' | translate: true"></p>
            <div class="rs-flex-row">
              <div class="rs-flex-columns small-12 medium-4">
                <mprd-norton-download></mprd-norton-download>
              </div>
              <div class="rs-flex-columns small-12 medium-4">
                <mprd-norton-anti-theft></mprd-norton-anti-theft>
              </div>
              <div class="rs-flex-columns small-12 medium-4">
                <mprd-norton-activation></mprd-norton-activation>
              </div>
            </div>

            <div class="rs-flex-row">
              <div class="rs-flex-columns small-12 medium-8">
                <mprd-norton-subscription></mprd-norton-subscription>
              </div>
              <div class="rs-flex-columns small-12 medium-4">
                <mprd-norton-family></mprd-norton-family>
              </div>
            </div>

            <div class="rs-me"></div>

            <h2>{{ 'norton.details.faqTitle' | translate }}</h2>

            <p [innerHTML]="'norton.details.faqContent' | translate: true"></p>
          </div>
          <div class="rs-le2"></div>
        </div>
      </div>
      <div class="row" *ngIf="isNortonFamily">
        <div class="columns small-12">
          <h1 class="rs-tit1-sp rs-txt-c2">{{ 'nortonFamily.subscription.title' | translate }}</h1>
          <div class="rs-panel-big rs-bg-c2 clearfix">
            <p>{{ 'nortonFamily.subscription.description' | translate }}</p>
            <div class="rs-flex-row">
              <div class="rs-flex-columns small-12 medium-6">
                <mprd-norton-family-download></mprd-norton-family-download>
              </div>
              <div class="rs-flex-columns small-12 medium-6">
                <mprd-norton-family-subscription></mprd-norton-family-subscription>
              </div>
            </div>
            <div class="rs-me"></div>
            <p [innerHTML]="'nortonFamily.details.faqContent' | translate: true"></p>
          </div>
          <div class="rs-le2"></div>
        </div>
      </div>
      <!-- START - FAQ -->
      <div [innerHtml]="faqHtml"></div>
      <!-- END - FAQ -->
    </section>
  </main>
</section>